import React, { FunctionComponent } from 'react'

type CollapseProviderProps = {
  state: boolean
}

const CollapseContext = React.createContext<boolean>(false)

const CollapseFromState: FunctionComponent<CollapseProviderProps> = ({ state, children }) => {
  return <CollapseContext.Provider value={state}>{children}</CollapseContext.Provider>
}

const useCollapse = (): boolean => {
  return React.useContext<boolean>(CollapseContext)
}

export { CollapseContext, CollapseFromState, useCollapse }
